import { Message } from 'primeng/api';

export class NotificationMessage implements Message {
  severity: string;
  summary: string;
  detail: string;
  id: any;
  key: string;
  life: number = 3000;
  sticky: boolean;
  closable: boolean = true;
  data: any;
}
